const getApiBaseUrl = () => {
  return "/api";
};

export default getApiBaseUrl;